import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle, TrendingUp } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const PeptideCard = ({ peptide }) => {
  const { language, t } = useLanguage();

  // Use translated names when available
  const displayName = language === 'pt' && peptide.name_translated 
    ? peptide.name_translated 
    : peptide.name;
  
  const displayCategory = language === 'pt' && peptide.category_translated 
    ? peptide.category_translated 
    : peptide.category;

  return (
    <div
      className="group bg-white border border-neutral-200 p-6 hover:border-red-600/50 transition-all duration-300 rounded-sm relative"
      data-testid={`peptide-card-${peptide.cat_no}`}
    >
      {/* Trending Badge */}
      {peptide.trending && (
        <div className="absolute -top-2 -left-2 z-10">
          <span className="badge badge-trending flex items-center gap-1 text-xs">
            <TrendingUp className="w-3 h-3" />
            {t('products.trending')}
          </span>
        </div>
      )}

      {/* Purity Badge */}
      <div className="absolute top-4 right-4">
        <span className="badge badge-purity font-mono text-xs">
          {peptide.purity || '≥99%'}
        </span>
      </div>

      {/* Content */}
      <div className="pr-16 pt-2">
        <p className="text-xs text-neutral-500 font-mono mb-1">{peptide.cat_no}</p>
        <h3
          className="text-lg font-bold text-neutral-900 mb-2 group-hover:text-red-600 transition-colors"
          style={{ fontFamily: 'Chivo, sans-serif' }}
        >
          {displayName}
        </h3>
        <p className="text-sm text-neutral-600 mb-1">{displayCategory}</p>
        <p className="text-sm font-medium text-neutral-900 font-mono">{peptide.concentration}</p>
      </div>

      {/* Description Preview */}
      <p className="text-sm text-neutral-500 mt-4 line-clamp-2">
        {language === 'pt' ? peptide.description_pt : peptide.description_en}
      </p>

      {/* Stock Status & CTA */}
      <div className="flex items-center justify-between mt-4 pt-4 border-t border-neutral-100">
        <div className="flex items-center gap-2">
          <CheckCircle className="w-4 h-4 text-green-600" />
          <span className="text-xs font-medium text-green-700">
            {t('products.inStock')}
          </span>
        </div>
        <Link
          to={`/peptide/${peptide.cat_no}`}
          className="flex items-center gap-1 text-sm font-medium text-red-600 hover:text-red-700 transition-colors"
          data-testid={`view-details-${peptide.cat_no}`}
        >
          {t('products.viewDetails')}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  );
};
